import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';

import * as fromRoot from '../store/reducers';
import * as JSZip from 'jszip';


@Injectable()
export class KeyboardActivityService implements OnDestroy {

    private maxKeyEvents = 20000; 
    private keyEvents = [];
    private isInitialized = false;
    private state = "pending";
    private jsZip: any;
    private recordingSessionId = null;

    constructor(
    ) {
        this.jsZip = new JSZip();
    }

    ngOnDestroy() {
        // unsubscribe to events. 
    }

    public startRecording(recordingSessionId) {
        this.recordingSessionId = recordingSessionId;
        if (this.isInitialized == false) {
            this.initializeKeyCapturing();
        }

        this.state = "recording";
        this.keyEvents = [];
    }

    public getRecordingSessionId(){
        return this.recordingSessionId;
    }

    public stopRecording() {
        this.state = "stopped";
		// unsubcribe and set the initialized back to false
    }  

    public isRecording(){
        return this.state == "recording";
    }

    public processKeyboardDataFile(onCompressedFile : Function){
        this.establishKeyboardZipFile(true, onCompressedFile);
    }

    private initializeKeyCapturing(){
        this.isInitialized = true;
        document.addEventListener("keydown", (e) => {this.onkeydown(e)});
        document.addEventListener("keyup", (e) => {this.onkeyup(e)});
    }

    private onkeydown(e){
        if (this.state == "recording") {
            if (this.keyEvents.length >= this.maxKeyEvents) {
                this.keyEvents.shift();
            }

            this.keyEvents.push({ type: "keydown", keyCode: e.keyCode, key: e.key, timeStamp: e.timeStamp });
        }
    }

    private onkeyup(e){
        if (this.state == "recording") {
            if (this.keyEvents.length >= this.maxKeyEvents) {
                this.keyEvents.shift();
            }
            this.keyEvents.push({ type: "keyup", keyCode: e.keyCode, key: e.key, timeStamp: e.timeStamp });
        }
    }

    private clearKeyboardActivity(){
        this.keyEvents = [];
    }
    
    private getCSVRepresentation() {
        if (this.keyEvents.length > 0) {
            var fields = Object.keys(this.keyEvents[0]);
            var replacer = function (key, value) { return value === null ? '' : value }
            var csv = this.keyEvents.map(function (row) {
                return fields.map(function (fieldName) {
                    return JSON.stringify(row[fieldName], replacer)
                }).join(',')
            })
            csv.unshift(fields.join(',')) // add header column
            return csv.join('\r\n');
        }
        else{
            // TO BE DETERMINED
            return "";
        }
    }

    private establishKeyboardZipFile(compress, onCompressedFile) {
        this.jsZip.file("KeyboardActivity.csv", this.getCSVRepresentation());
        var promise = null;
        var options = (compress == true)? {
            type: "blob",
            compression: "DEFLATE",
            compressionOptions: {
                level: 9
            }
        }
        :
        {
            type: "blob"
        }

        this.jsZip.generateAsync(options)
        .then((blob) =>  {   
            this.clearKeyboardActivity();          
            onCompressedFile(blob);
        });        
    }    

}




// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/keyboard-activity.service.ts